import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { Checkbox } from "@similarweb/ui-components";
import { CheckboxIcon } from "@similarweb/ui-components";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";
import SelectionDropdownView from "../../../../table-actions-panel/components/SelectionDropdown/SelectionDropdown";
import { withSWReactIconFillColor } from "../../../../advanced-search/components/common-styles";

export const StyledTitle = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["0"],
        $weight: 700,
        $size: 14,
        $family: fonts.$dmSansFontFamily,
    })};
    margin-left: 6px;
`;

export const StyledShareIcon = styled.div`
    margin-left: 34px;
    ${withSWReactIconFillColor(colorsPalettes.carbon["0"])};
`;

export const StyledSelectionDropdown = styled(SelectionDropdownView)`
    margin-left: 20px;
`;

export const StyledInfoIcon = styled.div`
    margin-left: 4px;

    & ${SWReactIcons} svg path:last-child {
        fill: ${colorsPalettes.carbon["0"]};
    }
`;

export const StyledCheckbox = styled(Checkbox)`
    & ${CheckboxIcon} svg path {
        fill: ${colorsPalettes.carbon["0"]};
        stroke: ${colorsPalettes.carbon["0"]};
    }
`;

export const StyledExcludeExportedSection = styled.div`
    align-items: center;
    display: flex;
    margin-left: 24px;

    & label {
        ${mixins.setFont({
            $size: 16,
            $color: colorsPalettes.carbon["0"],
        })};
        line-height: 20px;
    }
`;

export const StyledPanel = styled.div`
    align-items: center;
    display: flex;
`;
